
import React, { useState } from 'react'
import cardImg from "../assets/images/cardImg.svg";
import FileSaveOff from "../assets/images/FileSaveOff.svg";
import Checklist from "../assets/images/Checklist.svg";
import blue_email from "../assets/images/blue_email.svg";
import { AppContext } from '../contaxt/AppContext';
import ShieldQuestion from "../assets/images/ShieldQuestion.svg";
import AccessTime from "../assets/images/AccessTime.svg";
import nextplan from "../assets/images/nextplan.svg";
import { useNavigate } from 'react-router-dom';
import arrowRight from "../assets/images/arrow-right.svg";
import saveIconWhite from "../assets/images/SaveWhite.svg";
import languageIcon from "../assets/images/mobLanguage.svg";
import mobSaveIcon from "../assets/images/SaveBlue.svg";
import editProfileIcon from "../assets/images/editProfileBlue.svg";
import closeIcon from "../assets/images/closeIcon.svg";
import ExitIcon from "../assets/images/LogOutNew.svg";
import CheckCircleIcon from "../assets/images/checkGrey.svg";
import CheckCircleActvIcon from "../assets/images/checkGreen.svg";
import VerifiedUserWhite from "../assets/images/VerifiedUserWhite.svg";
import arrowUp from "../assets/images/ChevronUp.svg";
import { useDispatch, useSelector } from 'react-redux';
import { updateData } from '../redux/roundtoSlice';

export default function LywoTechnicalQuizStatus() {
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const currentStep = 2;

    const state = useSelector(state => state.roundData)

    const getProgressWidth = () => {
        if (currentStep === 1) return '33%';
        if (currentStep === 2) return '66%';
        if (currentStep === 3) return '100%';
    };

    const [showExitModal, setShowExitModal] = useState(false);

    const editProfile = () => {

        dispatch(updateData({ field: 'isEditDetails', value: true }))
        navigate("/JobApplicationProcess", { state: { fromOtherPage: true } })


    }

    return (
        <>
            <div className="paGeWrap m-botm">
                <div className="paGeWrap-pdg">
                    <div className='container colCntR'>
                        <h3>Dear {state.userName}</h3>
                        <h4>Great job! You’ve finished the Behavioral Assessment.</h4>
                        <div className="col-12 col-md-10 col-lg-8 emailNotifiTxt mobBgWrap">
                            <p>
                                <img src={blue_email} className="blueEmailIcon mb-1" />
                                We will send you an update on <span className="eMailaDrs">{state.userEmail}</span>
                            </p>
                        </div>
                        <div className='col-12 col-md-10 col-lg-8 mobBgWrap1'>
                            <div className='progressbarWrap'>
                                {/* <div className='progressHdr'>
                                <p>Your progress</p>
                                <p>Step {currentStep} of 3</p>
                            </div> */}

                                <div className="progressBarContainer">
                                    <div className="progressFill" style={{ width: getProgressWidth() }}>
                                    </div>
                                    {/* <div className="progressDots">
                                    <div className="dummyDot"></div>
                                    <div className="dummyDot"></div>
                                    <div className={`${currentStep === 2}`}></div>
                                    <div className="dot"></div>
                                </div> */}
                                </div>
                                <div className="mileStoneTxt">
                                    <div><p></p></div>
                                    <div className='milstnTxtImg'><img src={CheckCircleActvIcon} className="checkIcon" /><p className='mileStoneActv'>Preliminary info</p></div>
                                    <div className='milstnTxtImg'><img src={CheckCircleActvIcon} className="checkIcon" /><p className='mileStoneActv'>Behavior</p></div>
                                    <div className='milstnTxtImg'><img src={CheckCircleIcon} className="checkIcon" /><p>MCQ</p></div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-10 col-lg-8'>
                            <div className='behavr-box-wrap'>
                                <div className='behavr-txt-box pb-0'>
                                    <h2 className='next-step-lywo mb-0'>The Next Step is a Quiz</h2>

                                </div>
                                <div className='ARW-sec-flshScrn pt-0'>

                                    <div className='techQzbox'>
                                        <h6>Multiple Choice Quiz</h6>
                                        <p>Currently Not Assigned</p>
                                    </div>
                                    <h5 className='linHgt' style={{ marginBottom: "0px" }}>What happens next ?</h5>
                                    {/* <h2 className='next-step-lywo' style={{ fontSize: "16px", marginBottom: "0px", color: "#3a4b68" }}>What happens next ?</h2> */}

                                    <div className="instrctnBox">

                                        <div className='instrctnList'>
                                            <div className='instrctnNumWrap'>1</div>
                                            <p>Email notification will be sent to you, once the quiz is assigned</p>
                                        </div>
                                        <div className='instrctnList'>
                                            <div className='instrctnNumWrap'>2</div>
                                            <p>You'll receive the quiz link on the same email</p>
                                        </div>

                                    </div>
                                </div>
                                <div className='neWbTnAreaWrap'>
                                    <div className="btnLywo1" onClick={() => navigate("/LywoApplicattion2")}>
                                        <p>Exit</p>
                                        <img src={ExitIcon} className="mobIcon" alt="About Company" />
                                    </div>
                                    {/* <div className="btnLywo1" onClick={() => navigate("/LywoApplicattion2")}>
                                    <p>Let’s Start the Test</p>
                                    <img src={arrowRight} className="mobIcon" alt="About Company" />
                                </div>
                                <div className="btnLywo2" onClick={() => setShowExitModal(true)}>
                                    <p>Return Later to complete</p>
                                    <img src={saveIcon} className="mobIcon" alt="About Company" />
                                </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showExitModal && (
                    <div className="mcq-sbmt-modal-overlay">
                        <div className="mcq-sbmt-modal-content">
                            <div className="modal-top-close-btn">
                                <img src={closeIcon} className="mobIcon" alt="" onClick={() => setShowExitModal(false)} />
                            </div>

                            <div className="mcq-sbmt-modal-header">
                                <h4>Your progress has been saved</h4>
                            </div>
                            <div className="mcq-sccs-txt">
                                <p>
                                    You can return anytime to complete the test.
                                </p>
                            </div>

                            <div
                                className="mcq-sbmt-exit-btn"
                                onClick={() => {
                                    setShowExitModal(false);
                                    navigate("/Lywocode");
                                }}
                            >
                                <p>Save & Exit</p>
                            </div>
                        </div>
                    </div>
                )}

                <div className="mobile-icons">
                    {/* <div className="mobile-icon-txt" onClick={() => setShowExitModal(true)}>
                        <img src={mobSaveIcon} className="mobIcon" alt="Save & Exit" />
                        <p>Save & Exit</p>
                    </div> */}
                    <div className="mobile-icon-txt" onClick={editProfile}>
                        <img src={editProfileIcon} className="mobIcon" alt="Edit Profile" />
                        <p>Edit Profile</p>
                    </div>
                </div>

                <div className="dsktp-footer">
                   

                    <div className="dsktp-footer-right">
                        {/* <div className='lang-dsktp'>
                            <img src={languageIcon} className="mobIcon" alt="Select language" />
                            <p>Behavior test Language</p>
                            <div className='langbox-dsktp' onClick={() => setShowLanguagePopup(true)}>
                                <p>English</p>
                                <img src={arrowUp} className="mobIcon" alt="Select language" />
                            </div>
                        </div> */}

                        <button
                            className="comp-savebtn"
                            onClick={editProfile
                            }
                            style={{ width: "120px", padding: "8px 14px", height: "40px" }}
                        >
                            Edit Profile
                        </button>
                    </div>
                    <div className="dsktp-footer-left">
                        <div className="dsktp-footerjob-info">
                            <div className='v-u-bg'>
                                <img src={VerifiedUserWhite} className="vu-icon" alt="" />
                            </div>
                            <div className='v-u-jobcode'>
                                <h6>JOB-2024-001</h6>
                                <p>This application Process is Managed by <span>LYWO</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>

    )
}
